const expirationDays = 30;
const expirationTime = expirationDays * 24 * 60 * 60 * 1000;

// Shipping out of Metrotown -  AB, SK, BC, AB, SK
// Shipping out of Atrium - ON, MB, NB, NS, PE, NL

const mujiWarehouseLocations = document.getElementById("MujiWarehouseLocations");
const metroTownId = 55947133081;
const metroTown = mujiWarehouseLocations.dataset.warehouseMetrotown.split(',') || [];
const mujiMetroTown = 'MUJI Metrotown';
const atriumId = 55193239705;
const atrium = mujiWarehouseLocations.dataset.warehouseAtrium.split(',') || [];
const mujiAtrium = 'MUJI Atrium';

// Province Selector
function updateProvinceInStorage(province) {
    const expirationDays = 30;
    const expirationTime = expirationDays * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();
    const item = {
        value: province,
        expiry: now + expirationTime,
    };
    localStorage.setItem("canadianProvince", JSON.stringify(item));
}

// Function to add event listeners to all elements with the class .province-selector
function setupProvinceSelectors() {
    const provinceSelectors = document.querySelectorAll(".province-selector");

    provinceSelectors.forEach(selector => {
        selector.addEventListener("change", (event) => {
            const selectedProvince = event.target.value;
            updateProvinceInStorage(selectedProvince);
            
            // Update all other province selectors
            provinceSelectors.forEach(otherSelector => {
                if (otherSelector !== event.target) {
                    otherSelector.value = selectedProvince;
                }
            });
        });
    });
}

// PDP display availability
function getProvinceWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    
    if (!itemStr) return null;


    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    // Check if the item has expired
    if (now > item.expiry) {
        localStorage.removeItem(key); // Remove expired item
        return null;
    }
    return item.value;
}

function updateProvinceSelection(currentProvince) {
    const locationDropDown = document.querySelectorAll('.location-dropdown');
    locationDropDown.forEach(ldd => {
        const provinceSelector = ldd.querySelector('.province-selector');
        
        if(!provinceSelector) return;

        // Set default to ON if no province is selected
        const province = currentProvince || 'ON';
        const locationOptions = provinceSelector.querySelectorAll('option:not([value=""])');
        
        // Enable the selector and remove loading state
        provinceSelector.disabled = false;
        ldd.classList.remove('location-dropdown-loading');
        
        // Set the value directly instead of managing individual options
        provinceSelector.value = province;
        
        // Remove the initial load flag after setting the province
        provinceSelector.removeAttribute('data-initial-load');
    });
}

function updateNavigationMenu(currentProvince){
    // Get the current shipping location based on province
    let currentShippingLocation = shippingLocation(currentProvince);
    
    // If no shipping location is found, exit
    if (!currentShippingLocation) return;
    
    // Get links from footer (try multiple possible selectors)
    const footerLinks = document.querySelectorAll('footer a, .site-footer a, .footer a');
    const navigationLinks = document.querySelectorAll('.site-navigation a, .site-header a, nav a, .main-navigation a');
    const allTargetLinks = [...Array.from(footerLinks), ...Array.from(navigationLinks)];
    
    // Filter links that contain '/collections' in their href
    const collectionLinks = allTargetLinks.filter(link => {
        const href = link.getAttribute('href');
        return href && href.includes('/collections');
    });
    
    // Update each collection link to include the province parameter
    collectionLinks.forEach(link => {
        const href = link.getAttribute('href');
        
        // Skip if no href
        if (!href) return;
        
        // Create a URL object to parse the URL and get parameters
        let url;
        try {
            // For relative URLs, prepend with origin
            if (href.startsWith('/')) {
                url = new URL(href, window.location.origin);
            } else {
                url = new URL(href);
            }
            
            // Get all existing URL parameters
            const params = {};
            url.searchParams.forEach((value, key) => {
                params[key] = value;
            });
            
            // If there are no parameters (other than the one we just added),
            // add the location inventory filter
            if (Object.keys(params).length === 0) {
                url.searchParams.set('filter.v.m.locationInventory.locations', currentShippingLocation.location);
            } else {
                // Check if params contains any filter.v.m parameter but not the specific location filter
                const hasFilterVM = Object.keys(params).some(key => key.startsWith('filter.v.m'));
                const hasLocationFilter = Object.keys(params).some(key => key === 'filter.v.m.locationInventory.locations');
                
                if (hasFilterVM && !hasLocationFilter) {
                    // Add the location inventory filter to the existing filters
                    url.searchParams.set('filter.v.m.locationInventory.locations', currentShippingLocation.location);
                }
            }

            const newHref = url.pathname + url.search;
            link.setAttribute('href', newHref);
        } catch (e) {
            console.error('Error parsing URL:', href, e);
        }
    });
    
    return collectionLinks;
}

function shippingLocation(currentProvince){
    let currentShippingLocation;

    if(atrium.includes(currentProvince)){
        currentShippingLocation = {
            location: mujiAtrium,
            id: atriumId,
        }
    } else if(metroTown.includes(currentProvince)){
        currentShippingLocation = {
            location: mujiMetroTown,
            id: metroTownId,
        }
    } 

    return currentShippingLocation;
}

function getStockBasedOnSelection(inventoryInfoData, locationId){
    let findInventoryLocationIndex;
    let currentStoreStock = 0;

    findInventoryLocationIndex = inventoryInfoData.findIndex(iid => iid.location.id === locationId);

    if(findInventoryLocationIndex !== -1){
        currentStoreStock = inventoryInfoData[findInventoryLocationIndex].quantity;
    }

    return currentStoreStock;
}

function getStockBasedOnLocationId(inventoryInfoData, locationId){
    let findInventoryLocationIndex;
    let currentStoreStock = 0;

    findInventoryLocationIndex = inventoryInfoData.inventoryInfo.findIndex(iid => iid.location.id === locationId);

    if(findInventoryLocationIndex !== -1){
        currentStoreStock = inventoryInfoData.inventoryInfo[findInventoryLocationIndex].quantity;
    }

    return currentStoreStock;
}

function displayAvailabiltyByLocation(currentProvince){
    const inventoryInfoApp = document.getElementById('location-inventory-info');
    if(!inventoryInfoApp) return;

    let currentShippingLocation = shippingLocation(currentProvince)
    
    if(!currentShippingLocation) return;

    const locationContainers = document.querySelectorAll('.lli-list-item');
    if(locationContainers){
        locationContainers.forEach(location => {
            const locationContent = location.dataset.locationName.toLocaleLowerCase();
            if(locationContent.includes(currentShippingLocation.location.toLocaleLowerCase())){
                location.classList.remove('hide-lli');
            }
        })
    }
}

function setCollectionLocationFilter(currentSelectedProvince, updateProvince = false){
    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const locationString = "filter.v.m.locationInventory.locations";
    let currentShippingLocation = shippingLocation(currentSelectedProvince);
    
    if (!currentShippingLocation) return;

    // Check if the query parameters have filter.v.m.locationInventory.locations
    if (updateProvince) {
        if(queryParams.has(locationString)){
            queryParams.delete(locationString);
            queryParams.append(locationString, currentShippingLocation.location);
            url.search = queryParams.toString();
            window.history.replaceState(null, '', url.toString());
        }
    } else {
        if(!queryParams.has(locationString)){
            queryParams.append(locationString, currentShippingLocation.location);
            url.search = queryParams.toString();
            window.history.replaceState(null, '', url.toString());
            window.location.reload();
        }
    }
}

function updatePLPVariantSwatches(currentSelectedProvince){
    const productGridItems = document.querySelectorAll('.productgrid--item');
    const currentShippingLocation = shippingLocation(currentSelectedProvince);

    if(Array.from(productGridItems).length === 0 || !currentShippingLocation) return;

    productGridItems.forEach(productGridItem => {
        const swatchDataContainer = productGridItem.querySelector('.swatch-data');
        if(!swatchDataContainer) return;
        const swatchQuantityData = JSON.parse(swatchDataContainer.innerHTML);
        const swatches = productGridItem.querySelectorAll('label');
        swatches.forEach(swatch => {
            const swatchColor = swatch.dataset.swatchColor;
            
            const swatchFilterByColor = Object.entries(swatchQuantityData.variants_quantity)
                .filter(([variantId, variantData]) => variantData.color === swatchColor);

            const swatchColorQuantity = swatchFilterByColor.reduce((total, [variantId, variantData]) => {
                const locationInventory = variantData.inventory_info.find(info => 
                    info.location.id === currentShippingLocation.id
                );

                return total + (locationInventory ? locationInventory.quantity : 0);
            }, 0);

            if(swatchColorQuantity === 0) {
                swatch.remove();
            }
        });
    });
}

function extractInventoryInfo(currentSelectedProvince){
    const inventoryInfoApp = document.getElementById('inventory_info_metafield_data');
    const currentShippingLocation = shippingLocation(currentSelectedProvince);

    if(!inventoryInfoApp) return;

    let inventoryInfoData = JSON.parse(inventoryInfoApp.dataset.inventoryInfoMetafieldData);
    const inventoryInfoTranslations = JSON.parse(inventoryInfoApp.dataset.inventoryInfoTranslations);

    inventoryInfoData = inventoryInfoData.map(variantMetafield => {
        let tempVariantMetafield = variantMetafield;
        tempVariantMetafield.inventoryInfo = JSON.parse(tempVariantMetafield.inventoryInfo.replace(/&quoteFormat;/g, '"'));

        return tempVariantMetafield;
    });
    
    if(!inventoryInfoData) return;

    return {inventoryInfoData, inventoryInfoTranslations, currentShippingLocation};
}

function findSoldOutColors(currentShippingLocation, inventoryInfoData){
    const colorVariants = {};
    const soldOutColors = [];
    const enableHiddenVariants = document.querySelector('body[data-enable-hidden-variants]');
    const enableHiddenVariantsStatus = enableHiddenVariants.getAttribute('data-enable-hidden-variants') === 'true';
        
    if(!inventoryInfoData || !enableHiddenVariantsStatus) return;

    inventoryInfoData.forEach(variant => {
        const color = variant.option1;
        if (!colorVariants[color]) {
            colorVariants[color] = 0;
        }
        
        const locationInventory = variant.inventoryInfo.find(
            inv => inv.location.id === currentShippingLocation.id
        );
        
        if (locationInventory) {
            colorVariants[color] += locationInventory.quantity;
        }
    });
    
    // Identify colors that are completely sold out
    Object.keys(colorVariants).forEach(color => {
        if (colorVariants[color] === 0) {
            soldOutColors.push(color);
        }
    });

    return soldOutColors;
}


function updatePDP(currentSelectedProvince){
    const extractedInventoryInfo = extractInventoryInfo(currentSelectedProvince);
    const selectedVariant =  document.querySelector('variant-selection')
    if(!selectedVariant) return;
    let parsedSelectedVariant = JSON.parse(selectedVariant.dataset.variantLocation);

    updateATCButton(extractedInventoryInfo.currentShippingLocation, parsedSelectedVariant, extractedInventoryInfo.inventoryInfoTranslations);
    hideSoldOutColorVariant(extractedInventoryInfo.currentShippingLocation, extractedInventoryInfo.inventoryInfoData);
}

function updateQuickViewVariant(currentSelectedProvince){
    const {inventoryInfoData, currentShippingLocation} = extractInventoryInfo(currentSelectedProvince);
    hideSoldOutColorVariant(currentShippingLocation, inventoryInfoData);
}

function hideSoldOutColorVariant(currentShippingLocation, inventoryInfoData) {    
    const soldOutColors = findSoldOutColors(currentShippingLocation, inventoryInfoData);
    if (soldOutColors.length > 0) {
        hideColorOptions(soldOutColors);
    }
}

function hideColorOptions(soldOutColors) {
    const colorOptions = document.querySelectorAll('.options-selection__option-swatch-wrapper');
    
    if (!colorOptions.length) return;
    
    colorOptions.forEach(option => {
        const ariaLabel = option.getAttribute('data-swatch-tooltip');
        const ariaProductName = option.getAttribute('data-product-name').toLowerCase();
        const extractedAriaLabel = ariaLabel.replace(ariaProductName, '').replace('muji thumbnail', '').trim();
        
        let matches = false;
        for (let i = 0; i < soldOutColors.length; i++) {
            if (extractedAriaLabel.toLowerCase() === soldOutColors[i].toLowerCase()) {     
                matches = true;
                break;
            }
        }

        if (ariaLabel && matches) {
            option.style.display = 'none';
        }
    });
}

function updateATCButton(currentShippingLocation, inventoryInfoData, inventoryInfoTranslations){
    const productATC = document.querySelector('.product-form--atc-button');

    if(!productATC) return;
    let storeStock = getStockBasedOnSelection(inventoryInfoData, currentShippingLocation.id);

    if(storeStock > 0) {
        productATC.textContent = inventoryInfoTranslations.atc.add_to_cart
    } else {
        productATC.textContent = inventoryInfoTranslations.atc.sold_out
        if (!productATC.classList.contains('disabled')) {
            productATC.classList.add('disabled');
        }
    
        if (!productATC.hasAttribute('disabled')) {
            productATC.setAttribute ('disabled', '');
        }
    }
}

function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}

function setupQuickshopObserver() {
    const quickshopModal = document.getElementById('quickshop-modal');
    if (!quickshopModal) return;
        
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                const hasOptionValues = quickshopModal.querySelector('.options-selection__option-values');
                
                if (hasOptionValues) {
                    
                    const currentSelectedProvince = getProvinceWithExpiry('canadianProvince');
                    if (currentSelectedProvince) {
                        updateQuickViewVariant(currentSelectedProvince);
                        setupProductGalleryThumbnails(currentSelectedProvince)
                    }
                }
            }
        });
    });
    
    // Observe changes to the quickshop modal content
    observer.observe(quickshopModal, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });    
}

function setupProductGalleryThumbnails(currentSelectedProvince) {
  // Script will run everytime a product gallery is loaded
  // Start observing when DOM is ready

  (document.readyState === 'loading' 
    ? document.addEventListener('DOMContentLoaded', init) 
    : init());
  
  function init() {
    const checkOptions = () => document.querySelectorAll('.options-selection__option-values .options-selection__option-value-input[data-variant-option-available="true"]').length > 0;
    
    // Process thumbnails with available options
    function processThumbnails() {
      const extractedInventoryInfo = extractInventoryInfo(currentSelectedProvince);
      if(!extractedInventoryInfo || !extractedInventoryInfo.currentShippingLocation) return;
      const {inventoryInfoData, currentShippingLocation} = extractedInventoryInfo;
      const soldOutVariants = findSoldOutColors(currentShippingLocation, inventoryInfoData);

      const mediaThumbnails = document.querySelectorAll('.product-gallery--media-thumbnail');

      // Skip first thumbnail (index 0) and hide those that don't match any variant
      mediaThumbnails.forEach((thumbnail, i) => {
        if (i !== 0) {
          const ariaLabel = thumbnail.getAttribute('aria-label').toLowerCase();
          const ariaProductName = thumbnail.getAttribute('data-product-name').toLowerCase();
          const extractedAriaLabel = ariaLabel.replace(ariaProductName, '').replace('muji thumbnail', '').trim();
          
          let matches = false;
          for (let i = 0; i < soldOutVariants.length; i++) {
            if (extractedAriaLabel === soldOutVariants[i].toLowerCase()) {
              matches = true;
              break;
            }
          }
          
          if (matches) {
            thumbnail.style.display = 'none';
          }
        }
      });
    }
    
    // If options already exist, process immediately
    if (checkOptions()) {
      processThumbnails();
      return;
    }
    
    // Otherwise, observe for changes
    const observer = new MutationObserver(() => {
      if (checkOptions()) {
        observer.disconnect();
        processThumbnails();
      }
    });
    
    // Observe the entire document for attribute changes
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['data-variant-option-available']
    });
    
    // Stop observing after 5 seconds
    setTimeout(() => {
      observer.disconnect();
      processThumbnails();
    }, 5000);
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
    const locationDropDown = document.querySelectorAll('.location-dropdown .province-selector');
    const pageType = document.querySelector('[data-page-type');
    let currentSelectedProvince = getProvinceWithExpiry('canadianProvince');

    if(!currentSelectedProvince) {
        updateProvinceInStorage('ON');
        currentSelectedProvince = getProvinceWithExpiry('canadianProvince');
    }

    // Set up province selectors before any other operations
    setupProvinceSelectors();
    
    // Only update if we have a province selector with initial load flag
    const hasInitialLoadSelector = Array.from(locationDropDown).some(selector => 
        selector.hasAttribute('data-initial-load')
    );

    if (hasInitialLoadSelector) {
        // Short delay to show loading state
        setTimeout(() => {
            displayAvailabiltyByLocation(currentSelectedProvince);
            updatePDP(currentSelectedProvince);
            updatePLPVariantSwatches(currentSelectedProvince);
            updateProvinceSelection(currentSelectedProvince);
            updateNavigationMenu(currentSelectedProvince);
        }, 300);
    }
    
    if(!locationDropDown.length) return;

    if(pageType && pageType.dataset.pageType === 'collection'){
        setCollectionLocationFilter(currentSelectedProvince, false);
    }

    locationDropDown.forEach(ldd => {
        ldd.addEventListener('change', debounce((event) => {
            // Update all selectors immediately before page reload
            const selectedProvince = event.target.value;
            document.querySelectorAll('.province-selector').forEach(selector => {
                selector.value = selectedProvince;
            });

            if (pageType && pageType.dataset.pageType === 'collection') {
                currentSelectedProvince = getProvinceWithExpiry('canadianProvince');
                setCollectionLocationFilter(currentSelectedProvince, true);
            }

            location.reload();
        }, 1200));
    });

    setupQuickshopObserver();
});
